import { createContext, useContext } from "react";

export type TeamFilterTitles = {
    /** Maps a filter key → its resolved display title, for the filters this surface exposes. */
    byKey: ReadonlyMap<string, string>;
    /** Whether the filters config resolved. Until it does, a team's filters can be neither counted nor labelled. */
    isReady: boolean;
};

/**
 * The filter titles behind a team's filters summary, provided by the page that owns the filters config
 * and consumed by the teams table cell and its tooltip.
 *
 * Read through context rather than passed down as a prop: the teams table captures its column
 * render closures when it mounts, so a map that only resolves once the filters config loads would
 * never reach the cells. Context reaches the mounted cells directly.
 *
 * Defaults to unresolved: outside a provider no filter can be titled, so none is counted or shown.
 */
export const TeamFilterTitlesContext = createContext<TeamFilterTitles>({ byKey: new Map(), isReady: false });

export const useTeamFilterTitles = (): TeamFilterTitles => useContext(TeamFilterTitlesContext);
